import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

const path = `./assets/i18n/${environment.i18n}`;

export const translateLoader = provideTranslateHttpLoader({ prefix: path, suffix: '.json', enforceLoading: environment.firebase.projectId === 'isoharja-demo' });
